import axios from 'axios';

export default class RestClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
    this.a = axios.create({baseURL});
  }

  async get(apiUrl) {
    return await this.get_ex(apiUrl, {});
  }

  async del(apiUrl) {
    await this.call('DELETE', apiUrl);
  }

  async get_ex(apiUrl, options) {
    const r = await this.call('GET', apiUrl, {}, options);
    return options.all ? r : r.data;
  }

  async put(apiUrl, load) {
    const r = await this.call('PUT', apiUrl, load);
    return r.data;
  }

  async post(apiUrl, load) {
    return await this.call('POST', apiUrl, load);
  }

  async post_ex(apiUrl, load, options) {
    return await this.call('POST', apiUrl, load, options);
  }

  async call(method, apiUrl, load={}, options={}) {
    let params = {};
    if(options.params)
      params = options.params;

    let resp = null;

    try {
      switch(method) {
        case 'GET':
          resp = await this.a.get(`/${apiUrl}`, { params });
          break;
        case 'DELETE':
          resp = await this.a.delete(`/${apiUrl}`);
          break;
        case 'POST':
          resp = await this.a.post(`/${apiUrl}`, load);
          break;
        case 'PUT':
          resp = await this.a.put(`/${apiUrl}`, load);
          break;
        case 'PATCH':
          resp = await this.a.patch(`/${apiUrl}`, load);
          break;
        default:
          throw new Error(`unknown method ${method}`);
      }
    } catch(err) {
      this.throw_error(method, apiUrl, err.response, err);
    }

    if(options.nocheck)
      return resp;

    if(resp.status !== 200 || resp.data.status !== 'success') {
      if(resp.data && resp.data.message === 'not-signed-in' && RestClient.onNotSignedIn)
        RestClient.onNotSignedIn();
      throw new RestError(method, apiUrl, resp);
    }
      //this.throw_error(method, apiUrl, resp);

    return resp.data;
  }

  throw_error(method, apiUrl, resp, err=null) {
    let msg = resp && resp.status;
    if(err && err.message) msg += (" " + err.message);

    msg = `${method} /api/${apiUrl} ERROR [${msg}]`
    console.log(msg);
    console.log(resp);
    console.log(err);

    if(resp && resp.data && resp.data.message)
      msg = resp.data.message;

    throw new Error(msg);
  }
}

export class RestError extends Error {
  constructor(method, apiUrl, resp) {
    super(`${method} ${apiUrl} ${resp.data.status} ${resp.data.message}`);

    this.method = method;
    this.apiUrl = apiUrl;
    this.resp = resp;
    this.status = resp.data.status;
    this.msg = resp.data.message;
    this.uiMsg = this.parse(this.msg);

    console.log(this.message);
  }

  parse(msg) {
    switch(msg) {
      case 'not-found':
        return '没有指定数据';
      default:
        return msg;
    }
  }
}
